// All payroll data is mocked for now — the Vellum API has no payroll surface
// yet (PEAK-318). Replace this module with real SDK calls when it exists.

export type ApprovalStatus = "pending" | "approved";

export type PayrollWindow = {
  /** ISO date (yyyy-mm-dd), inclusive. */
  start: string;
  /** ISO date (yyyy-mm-dd), inclusive. */
  end: string;
};

export type PayrollUserSummary = {
  userId: string;
  name: string;
  role: string;
  jobsCompleted: number;
  totalPay: number;
  status: ApprovalStatus;
  /** Marks the row backing the logged-in user's own statement. */
  isCurrentUser: boolean;
};

export type PayrollJob = {
  id: string;
  completedAt: string;
  facility: string;
  procedure: string;
  basePay: number;
  bonus: number;
  travelMiles: number;
  mileageReimbursement: number;
};

export function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function daysAgoIso(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return toIsoDate(date);
}

/** Default payroll window: the last two weeks, ending today. */
export function getDefaultPayrollWindow(): PayrollWindow {
  return { start: daysAgoIso(13), end: daysAgoIso(0) };
}

export function jobTotal(job: PayrollJob): number {
  return job.basePay + job.bonus + job.mileageReimbursement;
}

export const MOCK_USERS: PayrollUserSummary[] = [
  {
    userId: "user-self",
    name: "You",
    role: "Field Nurse",
    jobsCompleted: 6,
    totalPay: 1287.4,
    status: "pending",
    isCurrentUser: true,
  },
  {
    userId: "user-amara",
    name: "Amara Osei",
    role: "Field Nurse",
    jobsCompleted: 9,
    totalPay: 1904.15,
    status: "approved",
    isCurrentUser: false,
  },
  {
    userId: "user-jordan",
    name: "Jordan Whitfield",
    role: "Triage Nurse",
    jobsCompleted: 4,
    totalPay: 812.0,
    status: "pending",
    isCurrentUser: false,
  },
  {
    userId: "user-priya",
    name: "Priya Raman",
    role: "Field Nurse",
    jobsCompleted: 11,
    totalPay: 2350.75,
    status: "approved",
    isCurrentUser: false,
  },
  {
    userId: "user-miguel",
    name: "Miguel Santana",
    role: "Field Nurse",
    jobsCompleted: 7,
    totalPay: 1512.6,
    status: "pending",
    isCurrentUser: false,
  },
];

/** Completed jobs for the logged-in user, dated inside the default window. */
export const MOCK_MY_JOBS: PayrollJob[] = [
  {
    id: "JOB-4821",
    completedAt: daysAgoIso(12),
    facility: "Willow Creek Skilled Nursing",
    procedure: "IV Infusion",
    basePay: 165.0,
    bonus: 25.0,
    travelMiles: 18.4,
    mileageReimbursement: 12.33,
  },
  {
    id: "JOB-4837",
    completedAt: daysAgoIso(10),
    facility: "Harborview Rehab Center",
    procedure: "PICC Line Placement",
    basePay: 210.0,
    bonus: 0,
    travelMiles: 26.1,
    mileageReimbursement: 17.49,
  },
  {
    id: "JOB-4842",
    completedAt: daysAgoIso(8),
    facility: "Sunrise Assisted Living",
    procedure: "Lab Draw",
    basePay: 95.0,
    bonus: 15.0,
    travelMiles: 9.7,
    mileageReimbursement: 6.5,
  },
  {
    id: "JOB-4859",
    completedAt: daysAgoIso(5),
    facility: "Willow Creek Skilled Nursing",
    procedure: "IV Infusion",
    basePay: 165.0,
    bonus: 40.0,
    travelMiles: 18.4,
    mileageReimbursement: 12.33,
  },
  {
    id: "JOB-4866",
    completedAt: daysAgoIso(3),
    facility: "Cedar Grove Memory Care",
    procedure: "Midline Placement",
    basePay: 185.0,
    bonus: 0,
    travelMiles: 31.2,
    mileageReimbursement: 20.9,
  },
  {
    id: "JOB-4874",
    completedAt: daysAgoIso(1),
    facility: "Harborview Rehab Center",
    procedure: "IV Infusion",
    basePay: 165.0,
    bonus: 25.0,
    travelMiles: 26.1,
    mileageReimbursement: 17.49,
  },
];
